import { render, staticRenderFns } from "./CatalogoListPublic.vue?vue&type=template&id=6dc90a83&scoped=true&lang=pug"
import script from "./CatalogoListPublic.vue?vue&type=script&lang=js"
export * from "./CatalogoListPublic.vue?vue&type=script&lang=js"
import style0 from "./CatalogoListPublic.vue?vue&type=style&index=0&id=6dc90a83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc90a83",
  null
  
)

export default component.exports